/* Customer photos row: most helpful first (operator 2026-10-14, sp-theme-dev-115: "show most helpful in this view but
   dont label it that way. make it most helpful in last 7 days ... for both video and photo media").

   Klaviyo draws the row from `product.review_images` and `product.videos` in its review list responses (its newest six
   photos and its newest videos). This script rewrites those two arrays before Klaviyo reads them: every review that
   has media is ranked by its helpful (up) votes from the last 7 days (simplepaper.app GET /api/review-votes, the same
   counts the review list shows), ties keep Klaviyo's own order, and the row is refilled from the ranked reviews,
   photos and videos alike, keeping Klaviyo's own counts. Nothing is labelled. With no votes in the window (or any
   failure, or a slow answer) the response passes through untouched, so the row is exactly Klaviyo's.

   Self-contained so it ships to Symmetry Live - WIP as one file plus one loader line: it carries its own copy of the
   review id (sp-review-votes.js spRvIdFor: product id + author + first 400 chars of text, FNV-1a) and reads the
   product id from #sp-rv26-ctx. Its own requests are XMLHttpRequest, so no fetch wrapper (sp-klaviyo-reviews-swap.js,
   sp-reviews-2026.js) sees them; it wraps fetch last, so it edits the body those wrappers hand back. */
(function () {
  if (window.__spRvMediaHelpful || !window.fetch) return;
  window.__spRvMediaHelpful = true;
  var ctx = document.getElementById('sp-rv26-ctx');
  var PID = ctx && ctx.dataset.pid;
  if (!PID || !/^\d{1,20}$/.test(PID)) return;
  var DAYS = 7, WAIT = 2500, PAGE = 50, MAX = 400;
  var LOCAL = /^(localhost|127\.0\.0\.1)$/.test(location.hostname);
  var VOTES = (LOCAL ? 'http://localhost:8686' : 'https://simplepaper.app') + '/api/review-votes?product_id=' + PID + '&days=' + DAYS;
  var LIST = /\/reviews\/api\/client_reviews\/(\d+)\/\?/;

  function hash(s) { var h = 0x811c9dc5; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193); } return (h >>> 0).toString(36); }
  function plain(s) { s = String(s || ''); if (/[<&]/.test(s)) s = new DOMParser().parseFromString(s, 'text/html').body.textContent || ''; return s.trim().replace(/\s+/g, ' '); }
  function idFor(r) { return 'r' + hash([PID, plain(r.author), plain(r.content).slice(0, 400)].join('|')); }
  function get(url) {
    return new Promise(function (ok) {
      var x = new XMLHttpRequest(); x.open('GET', url);
      x.onload = function () { try { ok(x.status < 300 ? JSON.parse(x.responseText) : null); } catch (e) { ok(null); } };
      x.onerror = function () { ok(null); }; x.send();
    });
  }
  function company() { var s = document.querySelector('script[src*="company_id="]'); var m = s && s.src.match(/company_id=([A-Za-z0-9]+)/); return m ? m[1] : 'RwSTEA'; }
  // every review with photos or videos, in Klaviyo's default order
  function mediaReviews() {
    var base = 'https://fast.a.klaviyo.com/reviews/api/client_reviews/' + PID + '/?product_id=' + PID + '&company_id=' + company() + '&sort=0&filter=&type=reviews&media=true&limit=' + PAGE;
    var rows = [];
    function page(off) {
      return get(base + '&offset=' + off).then(function (d) {
        var got = (d && d.reviews) || []; rows = rows.concat(got);
        return d && d.has_more && got.length && rows.length < MAX ? page(off + got.length) : rows;
      });
    }
    return page(0);
  }

  // started at once, so it is usually ready before Klaviyo asks for its first page
  var plan = Promise.all([get(VOTES), mediaReviews()]).then(function (res) {
    var counts = (res[0] && res[0].helpful) || {}, rows = res[1] || [];
    if (!Object.keys(counts).length || !rows.length) return null;
    var keyed = rows.map(function (r, i) { return { r: r, s: counts[idFor(r)] || 0, i: i }; });
    if (!keyed.some(function (k) { return k.s > 0; })) return null;
    keyed.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
    var images = [], videos = [];
    keyed.forEach(function (k) {
      var r = k.r, t = plain(r.content), title = t.length > 140 ? t.slice(0, 140) + '…' : t;
      String(r.image_uuid || '').split(',').filter(Boolean).forEach(function (u) { images.push({ id: r.id, title: title, uuid: u }); });
      (r.videos || []).forEach(function (v) { if (v && v.url) videos.push(v); });
    });
    return { images: images, videos: videos };
  })['catch'](function () { return null; });

  function within(p, ms) { return Promise.race([p, new Promise(function (ok) { setTimeout(function () { ok(null); }, ms); })]); }
  function rewrite(product, ranked) {
    if (!product || !ranked) return false;
    var changed = false;
    // keep Klaviyo's own counts: the row, its "+N" and "View all" stay the same size
    if (Array.isArray(product.review_images) && product.review_images.length) { product.review_images = ranked.images.slice(0, product.review_images.length); changed = true; }
    if (Array.isArray(product.videos) && product.videos.length) { product.videos = ranked.videos.slice(0, product.videos.length); changed = true; }
    return changed;
  }

  var prev = window.fetch;
  window.fetch = function (input, init) {
    var p = prev.apply(this, arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var m = LIST.exec(url);
    if (!m || m[1] !== PID || !/type=reviews/.test(url)) return p;
    return p.then(function (res) {
      if (!res || !res.ok) return res;
      return within(plan, WAIT).then(function (ranked) {
        if (!ranked) return res;
        return res.clone().json().then(function (d) {
          var a = rewrite(d && d.product, ranked), b = d && d.summary !== d.product && rewrite(d.summary, ranked);
          if (!a && !b) return res;
          return new Response(JSON.stringify(d), { status: res.status, statusText: res.statusText, headers: res.headers });
        })['catch'](function () { return res; });
      });
    });
  };
})();
